var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 21H1.8c-.6 0-1.2-.3-1.5-.9s-.3-1.2 0-1.8L9.4 1.9c.4-.6.9-.9 1.6-.9.7 0 1.2.3 1.6.9l9.2 16.5c.3.5.3 1.2 0 1.8-.4.5-.9.8-1.6.8zM11 2.2c-.2 0-.4.1-.5.3L1.3 18.9c-.1.2-.1.4 0 .6.1.2.3.3.5.3h18.5c.2 0 .4-.1.5-.3.1-.2.1-.4 0-.6L11.5 2.5c-.1-.2-.3-.3-.5-.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 15.7h1.2v2.4h-1.2zM10.4 7.4h1.2v7.1h-1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/Caution.164429ed.svg";
export { ForwardRef as ReactComponent };